import { useCallback, useEffect, useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CloseIcon } from "../../icons/Icon2";
import SlidingFilter2 from "../Dealers/SlidingFilter2";
import Button from "../Dealers/Button";
import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";

const SelectDM = ({
  mode,
  handleCloseModal,
  uniqueWarehouses,
  dispatchManagers,
  setShippingInfo,
  openShippingChargesInfoModal,
}) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(() => {
    const first = uniqueWarehouses?.[0];
    return first
      ? {
          label: first.warehouse,
          value: first.warehouseId,
        }
      : { label: "", value: "" };
  });

  const [selectedDmByWarehouse, setSelectedDmByWarehouse] = useState(() => {
    const initial = {};
    uniqueWarehouses.forEach((w) => {
      initial[w.warehouseId] = { label: "Auto", value: "auto" };
    });
    return initial;
  });

  const getManagerInstanceFromOptions = (manager, options) => {
    if (!manager || !manager.value) return {};
    return options.find((opt) => opt.value === manager.value) || {};
  };

  const openNextModal = useCallback(() => {
    setTimeout(() => {
      openShippingChargesInfoModal();
    }, 0);
  }, [openShippingChargesInfoModal]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key.toLowerCase() === "n") {
        openNextModal();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [openNextModal]);

  const warehouseChange = (warehouseId) => {
    const selectedWarehouseObj = uniqueWarehouses.find(
      (item) => item.warehouseId === warehouseId
    );

    if (selectedWarehouseObj) {
      setSelectedWarehouse({
        label: selectedWarehouseObj.warehouse,
        value: selectedWarehouseObj.warehouseId,
      });
    }

    const optionsForWarehouse = dispatchManagers
      .filter((m) => m.warehouseId === warehouseId)
      .map((m) => m);

    const saved = selectedDmByWarehouse[warehouseId];

    const instance = getManagerInstanceFromOptions(saved, [
      { label: "Auto", value: "auto" },
      ...optionsForWarehouse,
    ]);

    setSelectedDmByWarehouse((prev) => ({
      ...prev,
      [warehouseId]: instance,
    }));
  };

  const handleSelectManager = (manager) => {
    const isAuto = manager.value === "auto";

    setSelectedDmByWarehouse((prev) => ({
      ...prev,
      [selectedWarehouse.value]: manager,
    }));

    setShippingInfo((prevShippingInfo) =>
      prevShippingInfo.map((info) => {
        if (info.warehouseId === selectedWarehouse.value) {
          return {
            ...info,
            ...(!isAuto && { dmId: manager.value }),
          };
        }
        return info;
      })
    );

    const currentIndex = uniqueWarehouses.findIndex(
      (w) => w.warehouseId === selectedWarehouse.value
    );

    if (currentIndex === uniqueWarehouses.length - 1) {
      setTimeout(() => {
        openShippingChargesInfoModal();
      }, 0);
      return;
    }
    if (currentIndex < uniqueWarehouses.length - 1) {
      const next = uniqueWarehouses[currentIndex + 1];
      setSelectedWarehouse({
        label: next.warehouse,
        value: next.warehouseId,
      });

      const optionsForNext = dispatchManagers.filter(
        (m) => m.warehousename === next.warehouseId
      );
      const savedNext = selectedDmByWarehouse[next];
      const instanceNext = getManagerInstanceFromOptions(savedNext, [
        { label: "Auto", value: "auto" },
        ...optionsForNext,
      ]);
      setSelectedDmByWarehouse((prev) => ({
        ...prev,
        [next]: instanceNext,
      }));
    }
  };

  const filteredDispatchManagers = dispatchManagers.filter(
    (manager) => manager.warehouseId === selectedWarehouse.value
  );

  const currentOptions = [
    { label: "Auto", value: "auto" },
    ...filteredDispatchManagers,
  ];

  const selectedDm = getManagerInstanceFromOptions(
    selectedDmByWarehouse[selectedWarehouse.value],
    currentOptions
  );

  const warehouseDisplayList = uniqueWarehouses.map((w) => ({
    id: w.warehouseId,
    label: w.warehouse,
  }));

  return (
    <div
      className={styles.select_dm}
      style={{ backgroundColor: mode && "#232529" }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Select Dispatch Managers</p>

        <div className={styles.flex_2}>
          <div onClick={handleCloseModal}>
            <CloseIcon mode={mode} />
          </div>
        </div>
      </div>

      <div>
        <SlidingFilter2
          itemList={warehouseDisplayList.map((w) => w.label)}
          selectedItem={selectedWarehouse.label}
          setFilter={(label) => {
            const found = warehouseDisplayList.find((w) => w.label === label);
            if (found) {
              warehouseChange(found.id);
            }
          }}
          enableKeyboardNavigation
        />
      </div>

      <div className={styles.dm_list}>
        <VerticalDropDown2
          height={"37px"}
          fontSize={"12px"}
          label={"Select Manager"}
          options={currentOptions}
          dropDownOpen={true}
          onchange={handleSelectManager}
          value={selectedDm}
          preventAutoClose={true}
        />
      </div>

      <div className={styles.bottom_buttons} style={{ width: "100%" }}>
        <div style={{ width: "30%" }}>
          <Button
            buttonText={"Not Now"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={openNextModal}
            tabIndex={-1}
          />
          <p
            className={styles.btn_text}
            style={mode ? { color: "#FFFFFF" } : {}}
          >
            Press - N
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectDM;
